module.exports = __webpack_public_path__ + "img/HP_hero_mobile.a7e5b560.webp";